import { SvrConn } from "../utils/axios";

/**
 * Trae todos los modulos 
*/
export const getMessageAll = async () => {
    let res = {};
    try {
      res = await SvrConn.get("/api/message/getmessageall");
    } catch (Error) {
      res = Error;
    }
    return res;
  };
/**
*  Buscar Los Mensaje por area sin importar el estado
*/
export const getMessageAllxArea = async (AreaId) => {
    let res = {};
    try {
      res = await SvrConn.post("/api/message/getmessageallarea",{AreaId});
    } catch (Error) {
      res = Error;
    }
    return res;
  };
/**
 * 
 */
  export const setBloqueaMessage = async (AreaId, MensajeId, TagId) => {
    let res = {};
    try {
      res = await SvrConn.post("/api/message/setbloqueamessage", { AreaId, MensajeId,TagId });
    } catch (Error) {
      res = Error;
    }
    return res;
  };
  /**
   * 
   */
  export const getMessageInt = async (AreaId, MensajeId) => {
    let res = {};
    try {
      res = await SvrConn.post("/api/message/getmessageint",{AreaId, MensajeId});
    } catch (Error) {
      res = Error;
    }
    return res;
  };
  /**
 * 
 */
export const actualizaMessage = async(data)=>{
  let res = {};
    try {
      res = await SvrConn.post("/api/message/setactualizamessage", data);
    } catch (Error) {
      res = Error;
    }
    return res;

}
